import styled from 'styled-components';

import { UiTypography } from '@/components/ui/Typography';

import { OnboardingPage } from '../../../../components/Page';

export const Container = styled.div`
  margin: 0 16px;
  text-align: center;
`;

export const Title = styled(UiTypography)`
  margin: 0 0 8px;
`;

export const Subtitle = styled(UiTypography)`
  margin-bottom: 16px;
`;

export const ScreenAboutLookStyles = styled(OnboardingPage)`
  ion-content {
    &::part(scroll) {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-end;
      padding: 26px 0;
    }
  }
`;
